import {RsvpStatus} from '@wix/events-types'
import {getFormMessages} from '@wix/wix-events-commons-statics'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {FormStep, RSVP_STEPS} from '../../../constants/constants'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {getEvent} from '../../../selectors/event'
import {hasAgreedWithPolicies, hasPolicies as hasPoliciesSelector} from '../../../selectors/policies'
import {getCurrentStep, getResponse, getRsvpDetails, isStepCompleted, isStepVisible} from '../../../selectors/rsvp'
import {BuyerDetails} from '../../buyer-details'
import {Policies} from '../../policies'
import {RsvpFormContainerProps} from './interfaces'

export const RsvpFormContainer = ({children}: RsvpFormContainerProps) => {
  const {t} = useTranslation()
  const {submitRsvpStepOld, editRsvpStep} = useAppActions()

  const event = useAppSelector(getEvent)
  const currentStep = useAppSelector(getCurrentStep)
  const rsvpDetails = useAppSelector(getRsvpDetails)
  const agreedWithPolicies = useAppSelector(hasAgreedWithPolicies)
  const hasPolicies = useAppSelector(hasPoliciesSelector)
  const response = useAppSelector(getResponse)

  const {
    rsvp: {positiveMessages, negativeMessages, waitlistMessages},
  } = getFormMessages(event)

  const getSteps = () =>
    RSVP_STEPS.filter(step => isStepVisible({step, hasPolicies})).map(step => ({
      key: step,
      title: step === FormStep.BuyerDetails ? getTitle() : t(`mobile.checkout.step.${step}`),
      completed: isStepCompleted({
        step,
        rsvpDetails,
        agreedWithPolicies,
      }),
      renderStep: renderStep(step),
      onEdit: editRsvpStep,
    }))

  const getTitle = () => {
    if (response === RsvpStatus.YES) {
      return positiveMessages.title
    } else if (response === RsvpStatus.WAITING) {
      return waitlistMessages.title
    } else {
      return negativeMessages.title
    }
  }

  const renderStep = (step: FormStep) => {
    const props = {
      onSubmit: (data: any) => submitRsvpStepOld(data),
      t,
    }

    switch (step) {
      case FormStep.BuyerDetails:
        return (editing: boolean) => <BuyerDetails editing={editing} {...props} />
      case FormStep.Policies:
        return (editing: boolean) => <Policies editing={editing} {...props} />
      default:
        return () => null
    }
  }

  return children(getSteps(), currentStep)
}
